import React from 'react';

import { CmBox, CmButton, CmLabelAndInput } from '@/components/uiParts';
import { useInput } from '@/hooks/Form';

interface Props {
  onSubmit: (email: string) => Promise<void>;
}

export const Form: React.FC<Props> = ({ onSubmit }): JSX.Element => {
  const [email, emailProps] = useInput('', 'email');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email);
  };

  return (
    <CmBox as="form" mx={4} onSubmit={handleSubmit}>
      <CmLabelAndInput
        label={'メールアドレス'}
        id={'email'}
        isRequired
        {...emailProps}
      />
      {/*
       // @ts-ignore TS2590 */}
      <CmButton mt="4" type="submit" width="100%">
        送信する
      </CmButton>
    </CmBox>
  );
};
